import { Controller } from "@hotwired/stimulus"

// Two look-alike brands in the pop-up (release_watch/numbers/compare): what
// says which one stays and which moves (the heading, the Stays/Moves tags,
// the arrow, the merged brand's name) follows the name picked to keep.
export default class extends Controller {
  pick(event) {
    const kept = event.target.value
    this.element.querySelectorAll("[data-nb-keep]").forEach((el) => {
      el.hidden = el.dataset.nbKeep !== kept
    })
  }
}
